// extracted by mini-css-extract-plugin
export default {"feedImagesImage":"FeedImages_feedImagesImage__naK4U","feedImagesImageNumber":"FeedImages_feedImagesImageNumber__bmUvT"};